export default {
  USER_SETTINGS: 'User Settings',
  USER_PROFILE: 'Profile',
  USER_DOWNLOADS: 'Downloads',
  USER_MY_DOWNLOADS: 'My Downloads',
  DOWNLOADS_NONE_FOUND: 'No Downloads Found',
  DOWNLOADS_WHERE_THEY_BE: 'There are no downloads available.',
  DOWNLOADS_EXPORTED_LISTS: 'Exported Lists ({count})',
  DOWNLOADS_FILE: 'File',
  DOWNLOADS_CREATED_ON: 'Created On',
  DOWNLOADS_ACTION: 'Action',
  DOWNLOADS_REMAINING: 'remaining',
  DOWNLOADS_ERROR: 'There was a problem retrieving your download.',
  DOWNLOADS_DOWNLOADING: 'Downloading...',
};
